import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "breadcrumb",
  "aria-label": "breadcrumbs"
}

import { UseBreadcrumbBuilder } from "../../Helper/Stateful/BreadcrumbBuilder";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { breadcrumbUrls } = UseBreadcrumbBuilder();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbUrls), (urlObject, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: urlObject.level,
          class: _normalizeClass({
          'is-active': index === _unref(breadcrumbUrls).length - 1,
        })
        }, [
          _createVNode(_component_router_link, {
            to: urlObject.url
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(urlObject.level), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})